import React from 'react';
import { AssociateCourseCreate } from '../AssociateCourse/AssociateCourseCreate';
import { AssociateCourseEdit } from '../AssociateCourse/AssociateCourseEdit';
import AssociateCourseList from '../AssociateCourse/AssociateCourseList';
import { AssociateCourseShow } from '../AssociateCourse/AssociateCourseShow';

export default {
    list: AssociateCourseList,
    create: AssociateCourseCreate,
    edit: (props) => <AssociateCourseEdit {...props} courseType="Research" />,
};
